import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Set<string>} State */

/** @type {State} */
const initialState = new Set();

/**
 * @param {State} _ unused at the moment
 * @param {import('modules/notifications/types').FetchUnreadNotificationsCountActionSuccess} action
 * @returns {State}
 */
const set = (_, { payload: ids }) => {
  const newState = new Set();

  if (Array.isArray(ids)) {
    ids.forEach(id => newState.add(id));
  }

  return newState;
};

/** @returns {State} new Set */
const reset = () => new Set();

/**
 * @param {State}
 * @param {import('modules/notifications/types').AddNotificationAction}
 * @returns {State}
 */
const addAllAfterNewNotifications = (state, { payload }) => {
  const newState = new Set(state);

  payload.notifications?.forEach(({ id }) => newState.add(id));

  return newState;
};

/**
 * @param {State}
 * @param {import('modules/notifications/types').MarkAsReadActionSuccess}
 * @returns {State}
 */
const addOneAfterUnread = (state, { payload: notificationId }) => {
  const newState = new Set(state);

  newState.add(notificationId);

  return newState;
};

/**
 * @param {State} state
 * @param {import('modules/notifications/types').MarkAsReadActionSuccess|import('modules/notifications/types').DeleteNotificationActionSuccess} payload
 * @returns {State}
 */
const removeOne = (state, { payload: id }) => {
  const newState = new Set(state);
  newState.delete(id);
  return newState;
};

export default createReducer(initialState, {
  [types.ADD]: addAllAfterNewNotifications,
  [types.MARK_AS_UNREAD_SUCCESS]: addOneAfterUnread,
  [types.MARK_AS_READ_SUCCESS]: removeOne,
  [types.DELETE_NOTIFICATION_SUCCESS]: removeOne,
  [types.MARK_ALL_AS_READ_SUCCESS]: reset,
  [types.FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS]: set,
});
